import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IOffer } from "src/models/Offers/Offer.models";

interface OfferState {
  offers: IOffer[];
  offerToEdit: IOffer | null;
}

const initialState: OfferState = {
  offers: [],
  offerToEdit: null,
};

const OfferSlice = createSlice({
  name: "Offer",
  initialState,
  reducers: {
    setOfferList: (state, action: PayloadAction<IOffer[]>) => {
      state.offers = action.payload;
    },
    concatListOffer: (state: OfferState, action: PayloadAction<IOffer[]>) => {
      state.offers = [...state.offers.concat(action.payload)];
    },
    setOfferToEdit: (state, action: PayloadAction<IOffer | null>) => {
      state.offerToEdit = action.payload;
    },
    addOffer: (state, action: PayloadAction<IOffer>) => {
      state.offers.push(action.payload);
    },
    updateOffer: (state, action: PayloadAction<IOffer>) => {
      let itemIndex = state.offers.findIndex(
        item => item.offerId === action.payload.offerId
      );
      if (itemIndex !== -1) state.offers[itemIndex] = action.payload;
    },
    deleteOffer: (state, action: PayloadAction<number>) => {
      const newArray = state.offers.filter(
        item => item.offerId !== action.payload
      );
      state.offers = newArray;
    },
  },
});

export const {
  setOfferList,
  concatListOffer,
  setOfferToEdit,
  addOffer,
  updateOffer,
  deleteOffer,
} = OfferSlice.actions;

export default OfferSlice.reducer;
